module.exports = __webpack_public_path__ + "static/screenshot1-7f30d030fea201e98eac0baa9728d44e.jpg";